import api from '@/store/api/invoice'
import * as mutationTypes from './mutation-types'

const initialState = () => ({
    invoice: {}
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        invoice: state => state.invoice
    },
    actions: {
        /**
         * @param {{invoiceId: number}} data
         * @returns {Promise<*>}
         */
        showInvoice: async ({commit, dispatch}, data) => {
            try {
                const response = await api.showInvoice(data)
                commit(mutationTypes.SET_INVOICE, response)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetInvoice: async ({commit}) => commit(mutationTypes.RESET_INVOICE)
    },
    mutations: {
        [mutationTypes.SET_INVOICE]: (state, data) => state.invoice = data,
        [mutationTypes.RESET_INVOICE]: (state) => Object.assign(state, initialState())
    }
}
